import React from 'react';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import { CellBPKeywords, Row, CellContainer } from '@bit/knotchinc.web-react-components.table-sync';
import { ContentContainer, ValueContainer, Value, ValueDesc } from '../styled.js';

export const EntityKeywordsStatsRow = props => {
  const { data = {} } = props;

  return (
    <Row {...props} height="68">
      <CellContainer width={0.2}>
        <ContentContainer>
          <EntityItem data={data} dark />
        </ContentContainer>
      </CellContainer>
      <CellBPKeywords width={0.67} data={data} stats />
      <CellContainer width={0.13}>
        <ValueContainer>
          <Value>{data.num_contents}</Value>
          <ValueDesc>Content Pieces</ValueDesc>
        </ValueContainer>
      </CellContainer>
    </Row>
  );
};
